import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { Icon } from "rhombus-react";

import { formatBytes, isAdstudioCreative, isSocialCreative, KILO } from "utils/common";
import DICTIONARIES, { adType as adTypeDictionary } from "reducers/common/dictionaries";
import { IMAGE_ICONS } from "utils/constants";
import { shouldDisplayAction } from "utils/CreativeActions";
import { getCreativeClass } from "utils/CreativeMap";

import AdStudioLink from "widgets/actions/AdStudioLink";

import InfoItem from "./InfoItem";
import DecisioningHeader from "./DecisioningHeader";

import "./CreativesInfoHeader.css";

// import { AdvertiserName } from "../grid/cells/NameCell";

export default function InfoHeader(props){
	let currentLibrary = useSelector(state => state.libraryProperties)
		, currentCreative = useSelector(state => state.creativeDetails)
		, user = useSelector(state => state.you)
		, isLoading = !currentLibrary.isLoaded || !currentCreative.isLoaded
		, isLoadedClass = isLoading ? "is-loading" : ""
		, $items = []
		, $topName = "Libraries"
		, itemName = currentLibrary.name
		, itemId = currentLibrary.id
		, { advertiserName } = currentLibrary
		, campaignPrefix = "Versions - "
	;

	const { adType = "", id: creativeId } = currentCreative;
	const isAdStudio = isAdstudioCreative(currentCreative);
	const isSocial = isSocialCreative(currentCreative);
	const adClasses = {
		"type-icon":true,
		[`cell-type-creative-${adType}`]:true,
	};
	const iconName = adType.toLowerCase();
	const iconSrc = IMAGE_ICONS[iconName];

	let icon = <Icon name={iconName} aria-hidden={true} title={adType} className={classNames(adClasses)} />;
	let adStudioLink = null;

	if (iconSrc) {
		icon = <img src={iconSrc} aria-hidden title={adType} className={classNames(adClasses)} />;
	}

	if ((!isSocial && isAdStudio) || shouldDisplayAction.openInAdStudio(user, currentCreative)) {
  	adStudioLink = <AdStudioLink creativeId={creativeId} />;
	}

	if(/asset|creative/gi.test(props.type)){
		$topName = <Link to={`/library/${currentLibrary.id}/`}>{`${currentLibrary.name} (${currentLibrary.id})`}</Link>;
		itemName = "Assets";
		itemId = null;
	}

	if(/library|asset/gi.test(props.type)){
		if(currentLibrary.mediaBuyerName){
			$items.push(<InfoItem top="Media Buyer" value={currentLibrary.mediaBuyerName} className="media-buyer" key="media buyer" />);
		}

		if(currentLibrary.contentLimitInKilobytes){
			$items.push(<InfoItem top="Content Limit" value={formatBytes(currentLibrary.contentLimitInKilobytes * KILO)} className="content-limit" key="content-limit" />);
		}
	} else {
		// Versions info
		itemName = currentCreative.name;
		itemId = currentCreative.id;
		let decisioningValue = <DecisioningHeader libraryId={currentLibrary.id} creative={currentCreative} />;
		let creativeStatus = DICTIONARIES.approval.apiToUI[currentCreative.approval];

		if (isSocial) {
			$items = [
				<InfoItem top="Status" value={creativeStatus} className="status" key="status" />,
				<InfoItem top="Type" value={adTypeDictionary.apiToUI[adType]} key="type" />,
				<InfoItem top="# of Versions" value={currentCreative.numberOfVersions} className="num-versions" key="num-versions" />,
			];
		} else {
			$items = [
				<InfoItem top="Status" value={creativeStatus} className="status" key="status" />,
				<InfoItem top="Placement Size" value={currentCreative.placementSize} className="dimensions" key="dimensions" />,
				<InfoItem top="Total File Size" value={formatBytes(currentCreative?.totalFileSize?.totalSize)} className="total-file-size" key="total-file-size" />,
				<InfoItem top="# of Versions" value={currentCreative.numberOfVersions} className="num-versions" key="num-versions" />,
				<InfoItem top="Decisioning" value={decisioningValue} className="decisioning" key="decisioning" />
			];
		}
	}	//end if(library.test(props.type))

	return (
		<section className={`info-header campaign-info library-info flex-between ${isLoadedClass}`}>
			<header className="camp-name flex-around">
				<div className="upper-group flex-center blank-load">
					<h4 className="advertiser text-overflow">
						<span className="breadcrumb">{advertiserName}</span>
						<span className="camp-label">{$topName}</span>
					</h4>
				</div>
				<div className="lower-group flex-center blank-load">
					<h3 className={`campaign ${getCreativeClass(adType)}`} title={itemName}>
						{icon}
						<span className="campaign-name">{campaignPrefix}{itemName}</span>
						<span className="camp-id">{itemId}</span>
						{adStudioLink}
					</h3>
				</div>
			</header>
			<div className="camp-props flex-around">{$items}</div>
		</section>
	);
}

InfoHeader.defaultProps = {
	type:"",
};
InfoHeader.propTypes = {
	type:PropTypes.oneOf(["creative", "library", "asset"]).isRequired,
};
InfoHeader.displayName = "InfoHeader";
